/* MIYAGEN variant UX: chip injection + two-step picker (color -> size) */
(function () {
  var colorMap = {
    オレンジ: "#e67e22",
    レッド: "#e74c3c",
    イエロー: "#f1c40f",
    パープル: "#9b59b6",
    アクア: "#1abc9c",
    ブラック: "#1a1a1a",
    ホワイト: "#f5f5f5",
    ネイビー: "#2c3e50",
    ナミブ: "#c4a882",
    グレー: "#888888",
    カーキ: "#6b7c4e",
    サックス: "#6bb0c4",
  };
  var randomGrad = "linear-gradient(135deg, #e74c3c, #f1c40f, #1abc9c, #9b59b6)";

  function resolveColor(value) {
    var keys = Object.keys(colorMap);
    for (var i = 0; i < keys.length; i++) {
      if (value.indexOf(keys[i]) !== -1) return colorMap[keys[i]];
    }
    return "#cccccc";
  }

  function extractLabel(input, label) {
    var primary = "";
    var secondary = "";
    var p = label ? label.querySelector(".variant-label__primary") : null;
    var s = label ? label.querySelector(".variant-label__secondary") : null;
    if (p) primary = p.textContent.trim();
    if (s) secondary = s.textContent.trim();

    if (!primary) {
      var value = (input.value || "").replace(/\u3000/g, " ").trim();
      var parts = value.split(/\s+/);
      if (parts.length > 1) {
        secondary = parts[parts.length - 1];
        primary = value.slice(0, value.length - secondary.length).trim();
      } else {
        primary = value;
      }
    }
    return { primary: primary, secondary: secondary };
  }

  function sizeRank(sizeLabel) {
    var normalized = (sizeLabel || "").toUpperCase().replace(/\s+/g, "");
    if (normalized.indexOf("FREE") !== -1) return 999;
    if (normalized.indexOf("XXS") !== -1) return 0;
    if (normalized.indexOf("XS") !== -1) return 1;
    if (normalized.indexOf("S") !== -1 && normalized.indexOf("XS") === -1 && normalized.indexOf("XXS") === -1) return 2;
    if (normalized.indexOf("M") !== -1) return 3;
    if (normalized.indexOf("L") !== -1 && normalized.indexOf("XL") === -1) return 4;
    if (normalized.indexOf("XL") !== -1 && normalized.indexOf("XXL") === -1) return 5;
    if (normalized.indexOf("XXL") !== -1) return 6;
    return 100;
  }

  function injectChips() {
    var inputs = document.querySelectorAll(".product-form__input--pill.product-form__input--color input[type='radio']");
    inputs.forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== "LABEL") return;
      if (label.querySelector(".color-chip")) return;

      var chip = document.createElement("span");
      chip.className = "color-chip";
      chip.setAttribute("aria-hidden", "true");

      var val = input.value || "";
      if (val.indexOf("ランダム") !== -1) {
        chip.style.background = randomGrad;
      } else {
        chip.style.backgroundColor = resolveColor(val);
      }
      if (val.indexOf("ホワイト") !== -1) {
        chip.style.border = "1px solid #ccc";
      }
      label.insertBefore(chip, label.firstChild);
    });
  }

  function updateNotify(sectionId, entry) {
    if (!sectionId) return;
    var notify = document.getElementById("NotifyForm-" + sectionId);
    if (!notify) return;

    var body = notify.querySelector("[data-notify-body]");
    var handleInput = notify.querySelector("[data-notify-product-handle]");
    var productIdInput = notify.querySelector("[data-notify-product-id]");
    var productUrlInput = notify.querySelector("[data-notify-product-url]");
    var variantTitleInput = notify.querySelector("[data-notify-variant-title]");
    var variantIdInput = notify.querySelector("[data-notify-variant-id]");
    var variantSkuInput = notify.querySelector("[data-notify-variant-sku]");
    var productTitle = notify.getAttribute("data-product-title") || "";
    var productHandle = notify.getAttribute("data-product-handle") || "";
    var productId = notify.getAttribute("data-product-id") || "";
    var productUrl = notify.getAttribute("data-product-url") || window.location.pathname;
    var variantTitle = notify.getAttribute("data-variant-title") || "";
    var variantId = notify.getAttribute("data-variant-id") || "";
    var variantSku = notify.getAttribute("data-variant-sku") || "";

    if (entry) {
      variantTitle = entry.input.getAttribute("data-variant-title") || entry.input.value || variantTitle;
      variantId = entry.input.getAttribute("data-variant-id") || variantId;
      variantSku = entry.input.getAttribute("data-variant-sku") || variantSku;
    }

    if (handleInput) handleInput.value = productHandle;
    if (productIdInput) productIdInput.value = productId;
    if (productUrlInput) productUrlInput.value = productUrl;
    if (variantTitleInput) variantTitleInput.value = variantTitle;
    if (variantIdInput) variantIdInput.value = variantId;
    if (variantSkuInput) variantSkuInput.value = variantSku;

    var variantLabel = notify.querySelector("[data-notify-variant-label]");
    if (variantLabel) {
      var hasMeaningfulVariant = variantTitle && variantTitle !== "Default Title";
      variantLabel.textContent = hasMeaningfulVariant ? "「" + variantTitle + "」" : (productTitle ? "「" + productTitle + "」" : "");
    }

    // 抽選が終わった商品は continue 在庫で available=true のままなので、data-raffle-ended で表示を維持する。
    var raffleEnded = notify.getAttribute("data-raffle-ended") === "true";
    var btobOnly = notify.getAttribute("data-btob-only") === "true";
    var releaseWaiting = notify.getAttribute("data-release-waiting") === "true";
    var raffleScheduled = notify.getAttribute("data-raffle-scheduled") === "true";
    if (raffleEnded || btobOnly || (entry && !entry.available)) {
      notify.hidden = false;
      if (body) {
        body.value = [
          raffleScheduled ? "抽選開始お知らせ希望" : (releaseWaiting ? "発売お知らせ希望" : (raffleEnded ? "再販・次回入荷お知らせ希望(抽選終了後)" : "入荷お知らせ希望")),
          "product_title: " + productTitle,
          "variant_title: " + variantTitle,
          "product_handle: " + productHandle,
          "product_id: " + productId,
          "variant_id: " + variantId,
          "variant_sku: " + variantSku,
          "product_url: " + productUrl,
          "request_path: " + window.location.pathname + window.location.search,
        ].join("\n");
      }
    } else {
      notify.hidden = true;
    }
  }

  function setNotifyStatus(form, state, message) {
    if (!form) return;
    var status = form.querySelector("[data-notify-status]");
    if (!status) return;

    status.hidden = !message;
    status.textContent = message || "";
    status.classList.remove("is-success", "is-error", "is-loading");
    if (state) status.classList.add("is-" + state);
  }

  function setNotifySubmitting(form, submitting) {
    if (!form) return;
    var button = form.querySelector("button[type='submit']");
    var emailInput = form.querySelector("input[type='email']");
    if (button) button.disabled = !!submitting;
    if (emailInput) emailInput.disabled = !!submitting;
  }

  function buildNotifyEndpoint(baseUrl) {
    if (!baseUrl) return "";
    return baseUrl.indexOf("?") === -1 ? baseUrl + "?route=register" : baseUrl + "&route=register";
  }

  // スクリプト読込時刻 = フォーム表示の基準時刻。送信が速すぎる(<1.5s)bot を GAS 側で弾く。
  var NOTIFY_SCRIPT_T0 = Date.now();

  function registerNotify(form) {
    var notify = form && form.closest("[data-notify-form]");
    if (!notify) return Promise.resolve(false);

    var endpoint = buildNotifyEndpoint((notify.getAttribute("data-notify-endpoint") || "").trim());
    if (!endpoint) return Promise.resolve(false);

    var emailInput = form.querySelector("input[type='email']");
    var variantIdInput = notify.querySelector("[data-notify-variant-id]");
    var productHandleInput = notify.querySelector("[data-notify-product-handle]");
    var productIdInput = notify.querySelector("[data-notify-product-id]");
    var productUrlInput = notify.querySelector("[data-notify-product-url]");
    var variantTitleInput = notify.querySelector("[data-notify-variant-title]");
    var variantSkuInput = notify.querySelector("[data-notify-variant-sku]");

    var inventoryItemIdInput = notify.querySelector("[data-notify-inventory-item-id]");
    var productTitleAttr = notify.getAttribute("data-product-title") || "";
    var honeypotInput = notify.querySelector("[data-notify-honeypot]");

    var email = emailInput ? emailInput.value.trim() : "";
    var variantId = variantIdInput ? variantIdInput.value.trim() : "";

    if (!email) {
      setNotifyStatus(form, "error", "メールアドレスを入力してください。");
      return Promise.resolve(true);
    }

    if (!variantId) {
      setNotifyStatus(form, "error", "対象バリアントを特定できませんでした。");
      return Promise.resolve(true);
    }

    setNotifySubmitting(form, true);
    setNotifyStatus(form, "loading", "登録中です...");

    return fetch(endpoint, {
      method: "POST",
      mode: "no-cors",
      body: new URLSearchParams({
        email: email,
        variantId: variantId,
        productHandle: productHandleInput ? productHandleInput.value : "",
        productId: productIdInput ? productIdInput.value : "",
        productUrl: productUrlInput ? productUrlInput.value : "",
        variantTitle: variantTitleInput ? variantTitleInput.value : "",
        variantSku: variantSkuInput ? variantSkuInput.value : "",
        inventoryItemId: inventoryItemIdInput ? inventoryItemIdInput.value : "",
        productTitle: productTitleAttr,
        company: honeypotInput ? honeypotInput.value : "",
        t0: String(NOTIFY_SCRIPT_T0),
      }),
    })
      .then(function () {
        if (emailInput) emailInput.value = "";
        setNotifyStatus(form, "success", "登録を受け付けました。入荷時にメールでお知らせします。");
      })
      .catch(function () {
        setNotifyStatus(form, "error", "登録に失敗しました。時間をおいて再度お試しください。");
      })
      .finally(function () {
        setNotifySubmitting(form, false);
      })
      .then(function () {
        return true;
      });
  }

  function syncNotifyFromVariant(sectionId, variant) {
    if (!sectionId || !variant) return;
    var notify = document.getElementById("NotifyForm-" + sectionId);
    if (!notify) return;

    notify.setAttribute("data-variant-title", variant.title || "");
    notify.setAttribute("data-variant-id", variant.id != null ? String(variant.id) : "");
    notify.setAttribute("data-variant-sku", variant.sku || "");
    var invInput = notify.querySelector("[data-notify-inventory-item-id]");
    if (invInput && variant.inventory_item_id != null) invInput.value = String(variant.inventory_item_id);

    updateNotify(sectionId, {
      available: !!variant.available,
      input: {
        value: variant.title || "",
        getAttribute: function (name) {
          if (name === "data-variant-title") return variant.title || "";
          if (name === "data-variant-id") return variant.id != null ? String(variant.id) : "";
          if (name === "data-variant-sku") return variant.sku || "";
          return "";
        },
      },
    });
  }

  function updateSubmitButton(sectionId, entry) {
    if (!sectionId) return;
    var submit = document.getElementById("ProductSubmitButton-" + sectionId);
    if (!submit) return;
    var textNode = submit.querySelector("span");

    if (!entry) {
      submit.disabled = true;
      submit.setAttribute("aria-disabled", "true");
      if (textNode) textNode.textContent = "カラーとサイズを選択";
      return;
    }

    if (entry.available) {
      submit.disabled = false;
      submit.removeAttribute("aria-disabled");
    } else {
      submit.disabled = true;
      submit.setAttribute("aria-disabled", "true");
      if (textNode) textNode.textContent = "売り切れ";
    }
  }

  function mountStepPicker(fieldset) {
    if (!fieldset || fieldset.dataset.stepMounted === "true") return;
    var radios = Array.prototype.slice.call(fieldset.querySelectorAll("input[type='radio']"));
    if (!radios.length) return;

    var entries = radios.map(function (input) {
      var label = input.nextElementSibling && input.nextElementSibling.tagName === "LABEL" ? input.nextElementSibling : null;
      var parts = extractLabel(input, label);
      var dataColor = input.getAttribute("data-step-color") || "";
      var dataSize = input.getAttribute("data-step-size") || "";
      if (!dataSize && (dataColor.indexOf("/") !== -1 || dataColor.indexOf("／") !== -1)) {
        var separator = dataColor.indexOf("/") !== -1 ? "/" : "／";
        var splitted = dataColor.split(separator);
        dataColor = (splitted[0] || "").trim();
        dataSize = (splitted[1] || "").trim();
      }
      return {
        input: input,
        color: dataColor || parts.primary,
        size: dataSize || parts.secondary || "FREE",
        available: input.getAttribute("data-variant-available") === "true",
      };
    });

    var hasDistinctSizes = entries.some(function (e) {
      return e.size && e.size !== "FREE";
    });
    if (!hasDistinctSizes) {
      fieldset.dataset.stepMounted = "true";
      return;
    }

    var colors = [];
    var sizes = [];
    entries.forEach(function (e) {
      if (colors.indexOf(e.color) === -1) colors.push(e.color);
      if (sizes.indexOf(e.size) === -1) sizes.push(e.size);
    });
    sizes.sort(function (a, b) {
      var ra = sizeRank(a);
      var rb = sizeRank(b);
      if (ra !== rb) return ra - rb;
      return a.localeCompare(b, "ja");
    });

    var wrapper = document.createElement("div");
    wrapper.className = "variant-step-picker";
    wrapper.innerHTML =
      '<div class="variant-step-group variant-step-group--color">' +
      '<div class="variant-step-label">1. カラー <span class="variant-step-current" data-step-current-color>未選択</span></div>' +
      '<div class="variant-step-buttons variant-step-buttons--color" data-step-colors></div>' +
      "</div>" +
      '<div class="variant-step-group variant-step-group--size">' +
      '<div class="variant-step-label">2. サイズ <span class="variant-step-current" data-step-current-size>未選択</span></div>' +
      '<div class="variant-step-buttons variant-step-buttons--size" data-step-sizes></div>' +
      "</div>";

    var legend = fieldset.querySelector(".form__label");
    if (legend && legend.nextSibling) {
      fieldset.insertBefore(wrapper, legend.nextSibling);
    } else {
      fieldset.appendChild(wrapper);
    }

    var colorWrap = wrapper.querySelector("[data-step-colors]");
    var sizeWrap = wrapper.querySelector("[data-step-sizes]");
    var colorCurrent = wrapper.querySelector("[data-step-current-color]");
    var sizeCurrent = wrapper.querySelector("[data-step-current-size]");
    var selectedColor = fieldset.dataset.selectedColor || null;
    var selectedSize = fieldset.dataset.selectedSize || null;
    var variantSelects = fieldset.closest("variant-selects");
    var sectionId = variantSelects ? variantSelects.getAttribute("data-section") : "";

    if (!selectedColor || !selectedSize) {
      var checkedEntry = entries.find(function (e) {
        return e.input.checked;
      });
      if (checkedEntry) {
        selectedColor = checkedEntry.color;
        selectedSize = checkedEntry.size;
      }
    }

    function findEntry(color, size) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].color === color && entries[i].size === size) return entries[i];
      }
      return null;
    }

    function renderSizeButtons() {
      sizeWrap.innerHTML = "";
      sizes.forEach(function (size) {
        var exists = entries.some(function (e) {
          return e.color === selectedColor && e.size === size;
        });
        var soldOut = entries.some(function (e) {
          return e.color === selectedColor && e.size === size && !e.available;
        });
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "variant-step-btn";
        btn.dataset.size = size;
        btn.disabled = !selectedColor || !exists;
        if (!selectedColor || !exists) btn.classList.add("is-disabled");
        if (selectedSize === size) btn.classList.add("is-active");
        // ⚠ XSS 対策: `size` は admin が編集できる variant option 名。
        //   innerHTML に連結すると `</span><script>…` 注入が刺さる。textContent で組み立て。
        var sizeText = document.createElement("span");
        sizeText.className = "variant-step-btn__text";
        sizeText.textContent = size;
        if (soldOut) {
          var meta = document.createElement("div");
          meta.className = "variant-step-btn__meta";
          meta.textContent = "売り切れ（通知登録可）";
          sizeText.appendChild(meta);
        }
        btn.appendChild(sizeText);
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          selectedSize = size;
          applySelection(true);
        });
        sizeWrap.appendChild(btn);
      });
    }

    function renderColorButtons() {
      colorWrap.innerHTML = "";
      colors.forEach(function (color) {
        var dotColor = resolveColor(color);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "variant-step-btn";
        btn.dataset.color = color;
        if (selectedColor === color) btn.classList.add("is-active");
        // ⚠ XSS 対策: `color` は admin が編集できる variant option 名のため innerHTML 連結禁止。
        //   `dotColor` は colorMap から導出するので安全だが、経路統一で同じく DOM 生成に統一する。
        var dot = document.createElement("span");
        dot.className = "variant-step-btn__dot";
        dot.style.background = color.indexOf("ランダム") !== -1 ? randomGrad : dotColor;
        var colorText = document.createElement("span");
        colorText.className = "variant-step-btn__text";
        colorText.textContent = color;
        btn.appendChild(dot);
        btn.appendChild(colorText);
        btn.addEventListener("click", function () {
          selectedColor = color;
          if (!findEntry(selectedColor, selectedSize)) selectedSize = null;
          applySelection(true);
        });
        colorWrap.appendChild(btn);
      });
    }

    function applySelection(userAction) {
      renderColorButtons();
      renderSizeButtons();

      radios.forEach(function (r) {
        r.checked = false;
      });

      var entry = selectedColor && selectedSize ? findEntry(selectedColor, selectedSize) : null;
      if (entry) {
        if (userAction && !entry.input.checked) {
          entry.input.checked = true;
          entry.input.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (!userAction) {
          entry.input.checked = true;
        }
      }

      fieldset.dataset.selectedColor = selectedColor || "";
      fieldset.dataset.selectedSize = selectedSize || "";
      if (colorCurrent) colorCurrent.textContent = selectedColor || "未選択";
      if (sizeCurrent) sizeCurrent.textContent = selectedSize || "未選択";

      updateSubmitButton(sectionId, entry);
      updateNotify(sectionId, entry);
    }

    renderColorButtons();
    renderSizeButtons();
    applySelection(false);
    fieldset.dataset.stepMounted = "true";
  }

  function initAll() {
    injectChips();
    var stepFieldsets = document.querySelectorAll(".product-form__input--step");
    stepFieldsets.forEach(mountStepPicker);
  }

  var initScheduled = false;
  function scheduleInit() {
    if (initScheduled) return;
    initScheduled = true;
    requestAnimationFrame(function () {
      initScheduled = false;
      initAll();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleInit);
  } else {
    scheduleInit();
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains("notify-form__form")) return;

    var notify = form.closest("[data-notify-form]");
    if (!notify) return;

    var endpoint = (notify.getAttribute("data-notify-endpoint") || "").trim();
    if (!endpoint) return;

    event.preventDefault();
    registerNotify(form);
  });

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.sectionId || !event.data.variant) return;
      syncNotifyFromVariant(event.data.sectionId, event.data.variant);
    });
  }

  // 全バリアント品切れ時の救済: ラジオ変更を直接 listen し、
  // インライン product JSON から該当バリアントを引いて notify form を強制更新
  function findInlineProductVariants() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      var text = (scripts[i].textContent || "").trim();
      if (text.charAt(0) === "[" && text.indexOf('"id":') !== -1 && text.indexOf('"option1"') !== -1) {
        try { return JSON.parse(text); } catch (_) {}
      }
    }
    return null;
  }
  function findVariantByOptions(variants, optionValues) {
    if (!variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var o1 = optionValues[0] || null;
      var o2 = optionValues[1] || null;
      var o3 = optionValues[2] || null;
      if ((v.option1 || null) === o1 && (v.option2 || null) === o2 && (v.option3 || null) === o3) return v;
    }
    return null;
  }
  function getSelectedOptionValues(form) {
    var fieldsets = form.querySelectorAll("fieldset.product-form__input");
    var values = [];
    fieldsets.forEach(function (fs) {
      var checked = fs.querySelector("input[type='radio']:checked");
      values.push(checked ? checked.value : null);
    });
    return values;
  }

  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input || input.type !== "radio") return;
    var form = input.closest("form");
    var section = input.closest("[id^='MainProduct-'], section[id*='product']");
    var sectionId = section && section.id ? section.id.replace(/^MainProduct-/, "") : null;
    if (!sectionId) {
      var notify = document.querySelector("[data-notify-form]");
      if (notify) sectionId = notify.id.replace(/^NotifyForm-/, "");
    }
    if (!sectionId || !form) return;
    var variants = findInlineProductVariants();
    if (!variants) return;
    var optValues = getSelectedOptionValues(form);
    var variant = findVariantByOptions(variants, optValues);
    if (!variant) return;
    setTimeout(function () { syncNotifyFromVariant(sectionId, variant); }, 50);
    setTimeout(function () { syncNotifyFromVariant(sectionId, variant); }, 600);
  });

  var observer = new MutationObserver(function () {
    scheduleInit();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
